import { Pipe, PipeTransform } from "@angular/core"
import { tableNameDisplay } from "@app/helpers"

@Pipe({
	name: "tableNameDisplay",
})
export class TableNameDisplayPipe implements PipeTransform {
	transform(value: string): string {
		return tableNameDisplay(value)
	}
}
